import * as Yup from 'yup'

import category from 'components/forms/category/schema'
import emergencyContact from 'components/forms/emergencyContact/schema'
import participant from 'components/forms/participant/schema'

const schema = Yup.object().shape({
  ...category,
  ...emergencyContact,
  ...participant,
})

export default schema
